// @flow
import React from 'react';

import Avatar from 'material-ui/Avatar';
import FontIcon from 'material-ui/FontIcon';
import List, { ListItem } from 'material-ui/List';

import { STYLE_CATEGORIES } from 'utils/mapStyle';
import { OBTAINABLE_DESCRIPTIONS } from 'utils/results';

const styles = {
  container: {
    padding: 16,
  },
};

export default ({
  search: {
    availability_result: { obtainables },
  },
}) => (
  <div style={styles.container}>
    <p>
      A megadott adatok alapján az eseti légtérhasználat igényléséhez az
      alábbiakra van szükség:
    </p>
    <List style={{ marginBottom: 40 }}>
      {obtainables.map(o => (
        <ListItem
          key={`obtainable-${o}`}
          primaryText={OBTAINABLE_DESCRIPTIONS[o]}
          leftAvatar={
            <Avatar
              style={{ backgroundColor: STYLE_CATEGORIES.default.color }}
              color="white"
              icon={
                <FontIcon className="material-icons" size={12}>
                  description
                </FontIcon>
              }
            />
          }
          disabled
        />
      ))}
    </List>
  </div>
);



// WEBPACK FOOTER //
// ./components/SearchResultsDialog/ObtainablesList.js